/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import { NDC_TABS_DATA } from '../../Display/NDC/utility/constants';
import SearchByDrugName from './component/SelectClaim/SearchByDrugName';
import SearchByLabeler from './component/SelectClaim/SearchByLabeler';
import SearchByNDC from './component/SelectClaim/SearchByNDC';
import SelectClaimSearchComponent from './component/SelectClaim/SelectClaimSearchComponent';
import { NDCORClaimRadioData, RegularSuppData } from './utils/constant';
import { handleScrollToEvent } from '../../../SharedModules/CommonUtilities/commonUtilities';
import { setNumOfUnitsExtraState } from './store/action';

const UnitsClaim = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedClaimNDCTab = useSelector(
    (state) => state.sharedState.NumberOfUnits.selectedClaimNDCTab
  );

  const claimSelectByFilter = useSelector(
    (state) => state.sharedState.NumberOfUnits.claimSelectByFilter
  );

  const loading = useSelector((state) => state.sharedState.claim.loading);
  const errorPopupMessage = useSelector(
    (state) => state.sharedState.NumberOfUnits.errorPopupMessage
  );
  const successMessage = useSelector(
    (state) => state.sharedState.NumberOfUnits.successMessage
  );

  const selectBy = useSelector(
    (state) => state.sharedState.NumberOfUnits.selectBy
  );
  const extraState = useSelector(
    (state) => state.sharedState.NumberOfUnits.extraState
  );

  const [fullScreen, setFullScreen] = useState(false);
  const [error, setError] = useState(null);
  const setState = (value) => dispatch(setNumOfUnitsExtraState(value));
  const [isMounted, setIsMounted] = useState();

  useEffect(() => {
    handleScrollToEvent();
    const ele = document.querySelector('.nav-item-active a .tab-title');
    if (ele) {
      ele.textContent = 'Select Claim for Maintain';
    }
  }, []);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/units-claim') {
          if (errorPopupMessage?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorPopupMessage]);

  // Tab highlighter POC
  //  React.useEffect(() => {
  //   const errMsg = errorPopupMessage;
  //   const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  //   const newObj =
  //     updateTabs &&
  //     updateTabs.length > 0 &&
  //     updateTabs.map((item) => {
  //       if (item.navTo === '/units-selected-claim' && edit) {
  //         item.isFormDirty = true;
  //       } else {
  //         item.isFormDirty = false;
  //       }
  //       if (item.navTo === '/units-selected-claim') {
  //         if (edit && !_.isEmpty(errMsg)) {
  //           item.isFormError = true;
  //         } else {
  //           item.isFormError = false;
  //         }
  //       }
  //       return item;
  //     });
  //   localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  // }, [edit, errorPopupMessage]);

  // Close Popup POC---
  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/units-selected-claim' && x.isFormSave;
        }).length > 0
      ) {
        const newObj = updateTabs.map((item) => {
          if (item.navTo === '/units-selected-claim' && item.isFormSave) {
            item.isFormSave = false;
            // saveAndCloseTab();
          }
          return item;
        });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  return (
    <div className='tabs-container tBillPanel custom-check'>
      {loading && <Spinner load={loading} />}
      <CustomSeparator
        parent1='Maintain'
        parent2='Number of Units'
        parent3='Select Claim for Maintain'
      />
      {successMessage && (
        <DisplaySuccessMessages
          successMessages={
            typeof successMessage === 'string'
              ? [successMessage]
              : successMessage
          }
        />
      )}
      {errorPopupMessage && (
        <DisplayErrorMessages
          errorMessages={
            typeof errorPopupMessage === 'string'
              ? [errorPopupMessage]
              : errorPopupMessage
          }
        />
      )}
      {!fullScreen && (
        <SelectClaimSearchComponent
          selectedClaimNDCTab={selectedClaimNDCTab}
          claimSelectByFilter={claimSelectByFilter}
          selectBy={selectBy}
          error={error}
          setError={setError}
        />
      )}
      {selectBy === NDCORClaimRadioData[0].value && (
        <div className='row my-5'>
          {selectedClaimNDCTab === NDC_TABS_DATA[0].value && (
            <SearchByNDC
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
              setError={setError}
            />
          )}
          {selectedClaimNDCTab === NDC_TABS_DATA[1].value && (
            <SearchByDrugName
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
              setError={setError}
            />
          )}
          {selectedClaimNDCTab === NDC_TABS_DATA[2].value && (
            <SearchByLabeler
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
              setError={setError}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default UnitsClaim;
